import React from "react";
import * as FaIcons from "react-icons/fa";

const R11ReleaseRequests = ({
  formData,
  onFormDataChange,
  validationCheck,
}) => {
  const {
    firstName,
    releaseAudioAndVideo,
    releasePermissionForSocialMedia,
    releaseUseStudentWork,
    releasePermissionToTextStudent,
    releasePermissionToTextPg,
    releaseAllowStudentAccessToGoogleAppsForEducation,
  } = formData;
  return (
    <>
      {/* Release Requests */}
      <div className="sub-form">
        <h3>Release Requests</h3>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Release: Audio and Video</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <p className="under-title-note">
            I give permission for audio/video of{" "}
            {firstName === "" ? "the Student" : firstName} taken by the school
            to be used for school purposes.
          </p>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(releaseAudioAndVideo["yes"] || releaseAudioAndVideo["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={releaseAudioAndVideo["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="releaseAudioAndVideo"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={releaseAudioAndVideo["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="releaseAudioAndVideo"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Release: Permission for the School to use Student Pictures, Audio,
              Video, and Student work on Social Media
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <p className="under-title-note">
            Permission for the school to use{" "}
            {firstName === "" ? "the Student" : firstName}'s pictures, audio,
            video, and student work on social media
          </p>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  releasePermissionForSocialMedia["yes"] ||
                  releasePermissionForSocialMedia["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={releasePermissionForSocialMedia["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="releasePermissionForSocialMedia"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={releasePermissionForSocialMedia["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="releasePermissionForSocialMedia"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Release: Use Student Work</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <p className="under-title-note">
            I give permission for {firstName === "" ? "the Student" : firstName}
            's student work to be used in all school publications including the
            yearbook, newsletter, school bulletin boards, press releases, school
            web pages, or any other school sponsored displays.
          </p>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(releaseUseStudentWork["yes"] || releaseUseStudentWork["no"])
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={releaseUseStudentWork["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="releaseUseStudentWork"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={releaseUseStudentWork["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="releaseUseStudentWork"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Release: Permission to Text Student</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  releasePermissionToTextStudent["yes"] ||
                  releasePermissionToTextStudent["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={releasePermissionToTextStudent["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="releasePermissionToTextStudent"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={releasePermissionToTextStudent["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="releasePermissionToTextStudent"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>Release: Permission to Text Parent/Guardians</h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  releasePermissionToTextPg["yes"] ||
                  releasePermissionToTextPg["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={releasePermissionToTextPg["yes"]}
                onChange={(e) => onFormDataChange(e)}
                name="releasePermissionToTextPg"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={releasePermissionToTextPg["no"]}
                onChange={(e) => onFormDataChange(e)}
                name="releasePermissionToTextPg"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
        <div className="sum-item">
          <div className="asterisk-group">
            <h4>
              Release: Allow student access to Google Apps for Education (GAE)
            </h4>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border:
                validationCheck &&
                !(
                  releaseAllowStudentAccessToGoogleAppsForEducation["yes"] ||
                  releaseAllowStudentAccessToGoogleAppsForEducation["no"]
                )
                  ? "2px solid #d8302f"
                  : "",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={
                  releaseAllowStudentAccessToGoogleAppsForEducation["yes"]
                }
                onChange={(e) => onFormDataChange(e)}
                name="releaseAllowStudentAccessToGoogleAppsForEducation"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                value="no"
                checked={
                  releaseAllowStudentAccessToGoogleAppsForEducation["no"]
                }
                onChange={(e) => onFormDataChange(e)}
                name="releaseAllowStudentAccessToGoogleAppsForEducation"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default R11ReleaseRequests;
